module.exports = __webpack_public_path__ + "static/media/chevron-double.31a24ad4.svg";